import { FormattedMessage } from 'react-intl';
import { memo } from 'react';
import { Text } from '@library';
import { ProgressSpinner } from '../../../../../core/components/ProgressIndicators';
import type { SearchResultProduct } from '../../../../queries/useProductSearch';
import { SPARE_PART_PRODUCT_SEARCH_PAGE_SIZE } from '../../types';
import styles from './SkuProductSearchContent.module.scss';
import SkuProductSearchResult from './SkuProductSearchResult';

const SkuProductSearchContent = ({
    loading,
    products,
    total,
    searchTerm,
    openProduct,
}: {
    loading: boolean;
    products: SearchResultProduct[];
    total: number;
    searchTerm: string;
    openProduct: (product: SearchResultProduct) => void;
}) => {
    if (loading && products.length === 0) {
        return (
            <div className={styles.spinner}>
                <ProgressSpinner />
            </div>
        );
    }

    if (searchTerm.length < 2) {
        return (
            <div className={styles.baseMessage}>
                <Text secondary>
                    <FormattedMessage
                        id="Please type more than {count} characters"
                        values={{ count: 3 }}
                    />
                </Text>
            </div>
        );
    }

    if (products.length === 0) {
        return (
            <div className={styles.baseMessage}>
                <Text secondary>
                    <FormattedMessage id="No products found" />
                </Text>
            </div>
        );
    }
    return (
        <div>
            <div className={styles.message}>
                <Text secondary>
                    {products.length < SPARE_PART_PRODUCT_SEARCH_PAGE_SIZE ? (
                        <FormattedMessage
                            id='{resultsCount} results for "{searchTerm}"'
                            values={{
                                resultsCount: total,
                                searchTerm: searchTerm,
                            }}
                        />
                    ) : (
                        <FormattedMessage
                            id='Showing {productSearchPageSize} of {resultsCount} results for "{searchTerm}"'
                            values={{
                                productSearchPageSize:
                                    SPARE_PART_PRODUCT_SEARCH_PAGE_SIZE,
                                resultsCount: total,
                                searchTerm: searchTerm,
                            }}
                        />
                    )}
                </Text>
            </div>

            {searchTerm.length > 2 && (
                <SkuProductSearchResult
                    products={products}
                    searchTerm={searchTerm}
                    openProduct={openProduct}
                />
            )}
        </div>
    );
};

export default memo(SkuProductSearchContent);
